<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{ name: 'RegisterLeadStatus' }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <template v-if="hasLeadsStatus">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
              v-for="leadStatus in leadsStatus"
              :key="leadStatus.id"
            >
              <CardLeadStatus :lead-status="leadStatus" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardLeadStatus from "@/views/Company/components/CardLeadStatus";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Leads Status",
          routerName: "ListLeadsStatus",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      leadsStatus: "Company/leadsStatus",
    }),
    hasLeadsStatus() {
      return (
        this.leadsStatus &&
        Array.isArray(this.leadsStatus) &&
        this.leadsStatus.length > 0
      );
    },
  },
  components: {
    Breadcrumb,
    CardLeadStatus,
  },
  methods: {
    ...mapActions("Company", ["consultLeadsStatus"]),
  },
  mounted() {
    this.consultLeadsStatus();
  },
};
</script>
